module.exports = __webpack_public_path__ + "img/logo_nova.7ca19496.svg";